import { useState } from "react";
import emailjs from "emailjs-com";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiX } from "react-icons/si";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null); // null | "sending" | "ok" | "err"

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    emailjs
      .send("service_5xx6wy8", "template_3og6q9u", form, "f9gBmy7EVIjGTUlN4")
      .then(() => {
        setStatus("ok");
        setForm({ name: "", email: "", message: "" });
      })
      .catch(() => setStatus("err"));
  };

  const socials = [
    { icon: <AiFillGithub />,  href: "https://github.com/Vedantgaidhane",                                     label: "GitHub" },
    { icon: <FaLinkedinIn />,  href: "https://www.linkedin.com/in/vedant-gaidhane-4a4051208",                label: "LinkedIn" },
    { icon: <SiX />,           href: "https://x.com/VedantGaidhane?t=1pTPD2TV7g7Dsjb5xJq_rg&s=09",         label: "X" },
    { icon: <AiFillInstagram />,href: "https://www.instagram.com/vedant_gaidhane?igsh=MXI5cWwxcW9qenlsMg==",label: "Instagram" },
  ];

  return (
    <>
      <style>{`
        .contact-page {
          min-height: 100vh;
          background: var(--bg-primary);
          padding: 100px 20px 60px;
          display: flex; align-items: center; justify-content: center;
        }
        .contact-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          width: 100%; max-width: 1000px;
        }
        @media (max-width: 900px) {
          .contact-wrapper { grid-template-columns: 1fr; }
        }
        .contact-panel {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(108,99,255,0.18);
          border-radius: 20px;
          padding: 2.2rem;
          backdrop-filter: blur(14px);
        }
        .contact-label {
          display: block;
          font-size: 0.78rem; font-weight: 600;
          color: var(--primary);
          text-transform: uppercase; letter-spacing: 0.6px;
          margin-bottom: 5px;
        }
        .contact-input {
          width: 100%;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(108,99,255,0.20);
          border-radius: 10px;
          padding: 0.65rem 0.9rem;
          color: #e2e8f0;
          font-size: 0.92rem;
          font-family: inherit;
          outline: none;
          transition: all 0.22s ease;
          margin-bottom: 1.1rem;
        }
        .contact-input:focus {
          border-color: var(--primary);
          background: rgba(108,99,255,0.07);
          box-shadow: 0 0 0 3px rgba(108,99,255,0.12);
        }
        .contact-textarea {
          resize: vertical; min-height: 120px;
        }
        .contact-submit {
          width: 100%;
          background: linear-gradient(135deg, var(--primary), #8b5cf6);
          border: none; border-radius: 10px;
          padding: 0.75rem;
          color: #fff; font-weight: 600; font-size: 0.95rem;
          cursor: pointer; transition: all 0.22s ease;
          letter-spacing: 0.3px;
          box-shadow: 0 4px 18px rgba(108,99,255,0.30);
        }
        .contact-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 28px rgba(108,99,255,0.45);
        }
        .contact-submit:disabled { opacity: 0.65; cursor: not-allowed; }
        .info-row {
          display: flex; align-items: center; gap: 0.9rem;
          padding: 1rem 0;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .info-row:last-of-type { border-bottom: none; }
        .info-icon {
          width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
          background: rgba(108,99,255,0.10);
          border: 1px solid rgba(108,99,255,0.20);
          display: flex; align-items: center; justify-content: center;
          font-size: 1.05rem;
        }
        .info-text-label { font-size: 0.72rem; color: var(--muted); margin-bottom: 2px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.4px; text-align: left; display: block; }
        .info-text-value { font-size: 0.9rem; color: #e2e8f0; text-align: left; display: block; font-weight: 500; }
        .info-text-value a { color: var(--primary); text-decoration: none; }
        .info-text-value a:hover { text-decoration: underline; }
        .info-text { display: flex; flex-direction: column; justify-content: center; }
        .social-row {
          display: flex; gap: 0.6rem; flex-wrap: wrap;
          margin-top: 1.4rem;
        }
        .social-btn {
          display: flex; align-items: center; gap: 7px;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.09);
          border-radius: 10px; padding: 0.5rem 1rem;
          color: var(--muted); font-size: 0.82rem; font-weight: 500;
          text-decoration: none; transition: all 0.22s ease;
          cursor: pointer;
        }
        .social-btn:hover {
          background: rgba(108,99,255,0.10);
          border-color: rgba(108,99,255,0.30);
          color: var(--primary);
          transform: translateY(-2px);
        }
        .status-msg {
          margin-top: 0.75rem; padding: 0.6rem 0.9rem;
          border-radius: 8px; font-size: 0.85rem; font-weight: 500;
          text-align: center;
        }
        .status-ok  { background: rgba(0,212,170,0.10); border: 1px solid rgba(0,212,170,0.25); color: #00d4aa; }
        .status-err { background: rgba(239,68,68,0.10);  border: 1px solid rgba(239,68,68,0.25);  color: #f87171; }
      `}</style>

      <div className="contact-page">
        <div className="contact-wrapper">

          {/* ── Left: Info panel ─────────────────── */}
          <div className="contact-panel">
            <h2 style={{ fontSize: "1.7rem", fontWeight: 800, color: "#fff", marginBottom: 4 }}>
              Let's <span style={{ color: "var(--primary)" }}>Connect</span>
            </h2>
            <p style={{ color: "var(--muted)", fontSize: "0.9rem", marginBottom: "1.6rem", lineHeight: 1.7 }}>
              Open to cloud consulting, full-time roles, and interesting conversations about
              DevSecOps, FinOps, or infrastructure at scale.
            </p>

            <div className="info-row">
              <div className="info-icon">📧</div>
              <div className="info-text">
                <span className="info-text-label">Email</span>
                <span className="info-text-value">
                  <a href="mailto:vedantkgaidhane@gmail.com">vedantkgaidhane@gmail.com</a>
                </span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-icon">📞</div>
              <div className="info-text">
                <span className="info-text-label">Phone</span>
                <span className="info-text-value">+91 7264926849</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-icon">📍</div>
              <div className="info-text">
                <span className="info-text-label">Location</span>
                <span className="info-text-value">Nagpur, Maharashtra, India</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-icon">💼</div>
              <div className="info-text">
                <span className="info-text-label">Focus</span>
                <span className="info-text-value">Cloud &amp; DevOps · AWS FinOps &amp; Cost Optimization</span>
              </div>
            </div>

            {/* Socials */}
            <div className="social-row">
              {socials.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="social-btn" aria-label={s.label}>
                  {s.icon}
                  <span>{s.label}</span>
                </a>
              ))}
            </div>
          </div>

          {/* ── Right: Contact form ───────────────── */}
          <div className="contact-panel">
            <h2 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#fff", marginBottom: "1.5rem" }}>
              Send a <span style={{ color: "var(--primary)" }}>Message</span>
            </h2>

            <form onSubmit={handleSubmit} autoComplete="off">
              <label className="contact-label">Your Name</label>
              <input
                type="text"
                name="name"
                className="contact-input"
                placeholder="e.g. Virat Kohli"
                value={form.name}
                onChange={handleChange}
                required
              />

              <label className="contact-label">Email Address</label>
              <input
                type="email"
                name="email"
                className="contact-input"
                placeholder="you@xyz.com"
                value={form.email}
                onChange={handleChange}
                required
              />

              <label className="contact-label">Message</label>
              <textarea
                name="message"
                className="contact-input contact-textarea"
                placeholder="Tell me about your project or opportunity..."
                value={form.message}
                onChange={handleChange}
                required
              />

              <button
                type="submit"
                className="contact-submit"
                disabled={status === "sending"}
              >
                {status === "sending" ? "Sending…" : "Send Message →"}
              </button>

              {status === "ok" && (
                <div className="status-msg status-ok">
                  ✓ Message sent! I'll get back to you soon.
                </div>
              )}
              {status === "err" && (
                <div className="status-msg status-err">
                  ✗ Something went wrong — please email me directly.
                </div>
              )}
            </form>
          </div>

        </div>
      </div>
    </>
  );
}

export default Contact;
